// extracted by mini-css-extract-plugin
export default {"container":"ContainerCard_container__EVI36"};